import React from "react";
import { Updater } from "use-immer";

import { IgSelect } from "@intelligems/ig-theme";
import { MenuItem, SelectChangeEvent } from "@mui/material";
import { useSelector } from "@src/store";
import { selectedVariations } from "@src/store/slices/variations";

interface VariationHeaderDropdownProps {
  selectedVariationId: string;
  setSelectedVariationId: Updater<string>;
  showAllOption?: boolean;
}
export const VariationHeaderDropdown = ({
  showAllOption,
  selectedVariationId,
  setSelectedVariationId,
}: VariationHeaderDropdownProps) => {
  const variations = useSelector(selectedVariations);
  const handleChange = (event: SelectChangeEvent<any>) => {
    setSelectedVariationId(event.target.value as string);
  };

  return (
    <IgSelect
      // autoWidth={true}
      disableUnderline={true}
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={selectedVariationId}
      variant={"standard"}
      sx={{
        fontSize: "14px",
        "& .MuiSelect-select": {
          padding: 0,
        },
        "& .MuiTypography-root": {
          fontSize: "14px",
          fontWeight: 600,
        },
      }}
      onChange={handleChange}
    >
      {showAllOption && (
        <MenuItem
          sx={{ fontSize: "14px" }}
          disableTouchRipple={true}
          dense
          key={"all"}
          value={"all"}
        >
          All
        </MenuItem>
      )}
      {variations.map((group) => (
        <MenuItem sx={{ fontSize: "14px" }} key={group.id} value={group.id}>
          {group.name}
        </MenuItem>
      ))}
    </IgSelect>
  );
};
